export function DeduplicateArray(arr) {
    return arr.filter(function (item, index) {
        return arr.indexOf(item) >= index;
    });
}

// Flattens the per-shipment product lists on a checkout transaction into a single
// array. Shared by the confirmation analytics middlewares (GA, Facebook, Constructor).
export function flattenShipmentProducts(transaction) {
    var products = [];
    var container = transaction && transaction.shippingMethodContainer;
    var shipments = (container && container.shipments) || [];
    shipments.forEach(function (shipment) {
        products.push.apply(products, shipment.products || []);
    });
    return products;
}